import { render, staticRenderFns } from "./johansen.vue?vue&type=template&id=1106984f&"
import script from "./johansen.vue?vue&type=script&lang=js&"
export * from "./johansen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports